import styled, { createGlobalStyle } from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledGoogleMapContainer = styled.div`
  width: 100%;
  height: 100%;

  .active-map-pin {
    background-color: ${baseVariables.color.base20};
  }

  .gm-style-iw-c {
    box-shadow: none;
  }

  .m-map-pin {
    font-size: ${toRem(12)} !important;

    ::before {
      font-size: ${toRem(16)};
    }
    &.active-map-pin::after {
      border-color: ${baseVariables.color.base20}transparent transparent transparent;
    }
  }

  .rnb-error-container {
    position: absolute;
    top: ${toRem(58)};
    z-index: 1;
    width: auto;
    display: block;

    @media ${baseVariables.mediaQuery.sm} {
      width: 97vw;
    }

    @media ${baseVariables.mediaQuery.xl} {
      display: none;
    }

    .rnb-error-message {
      width: auto;

      @media ${baseVariables.mediaQuery.sm} {
        width: 96vw;
      }

      @media ${baseVariables.mediaQuery.lg} {
        width: 97vw;
      }
    }
  }
`;

export const GlobalStyle = createGlobalStyle`
  .gm-style-iw {
      max-width: unset !important;
      background: none !important;
    }
`;
